import type { IAugmentedJQuery, IScope } from "angular";
import { throttle } from "lodash";

import type IMasonryService from "../../Services/Masonry/IMasonryService";

export default class MasonryReloadOnExpandController {
    public static $inject: string[] = ["$scope", "$element", "irMasonryService"];

    private changes: MutationObserver;

    constructor(
        private readonly $scope: IScope,
        private readonly $element: IAugmentedJQuery,
        private readonly masonryService: IMasonryService,
    ) {}

    public $onInit() {
        const throttleReload = throttle(() => {
            this.masonryService.reload(500);
        }, 100);

        this.changes = new MutationObserver((mutations: MutationRecord[]) => {
            mutations.forEach((mutation: MutationRecord) => {
                if (mutation.attributeName === "aria-expanded") {
                    throttleReload();
                }
            });
        });

        this.changes.observe(this.$element[0], {
            attributeFilter: ["aria-expanded"],
            attributes: true,
            characterData: false,
            childList: false,
            subtree: true,
        });
    }

    public $onDestroy() {
        this.changes.disconnect();
    }
}
